import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import anime from 'animejs'
import history from '../../history'
import { withLocalize } from "react-localize-redux";

import { InputPassword } from '../input/InputText.tsx'
import SvgLogin from './SvgLogin';

import { LOGOUT_USER } from '../../actions/types'
import { logoutUser, resetPassword, resetMessage } from '../../actions/auth'

class ResetPassword extends React.Component {

  constructor(props){
      super(props)
      this.domainName = window.location.hostname;
    this.state = {
      fields : 2,
      token : null,
      form : {
        "password":"", 
        "password-2":""
      }
    }
  }

  UNSAFE_componentWillReceiveProps(NextProps){
    if(NextProps.message === "Votre mot de passe à été modifié. Vous pouvez désormais vous connecter avec votre nouveau mot de passe."){
      this.timer = setTimeout(()=>{
        history.push('/');
        clearTimeout(this.timer)
      },4000);
    }
  }

  componentWillUnmount(){
    clearTimeout(this.timer)
    this.props.resetMessage();
  }

  componentDidMount(){
    anime({
      targets: '#ImgGreyShape',
      scale: {
        value : [0.3, 0.9],
        duration : 600,
      },
      easing: 'easeOutQuad'
    });

    anime({
      targets: '#imgCharacter',
      scale: {
        value : [0, 0.9],
        duration : 600,
        delay : 300
      },
      easing: 'easeOutQuad'
    });

    anime({
      targets: '#imgFlower',
      scale: {
        value : [0, 0.9],
        duration : 800,
        delay : 300
      },
      easing: 'easeOutQuad'
    });
  }

  UNSAFE_componentWillMount(){
    if(this.props.authenticated) this.props.logoutUser('',LOGOUT_USER)
    var token = this.props.match.params.token
    this.setState({token})
  }



  handleInputChange(obj, bool){
    
    var form = Object.assign({},this.state.form);
    form[obj.target.name] = {value : obj.target.value, isValid : obj.target.value !== "" ? true : false};
    this.setState({form : form})

  }

  validateNewPassword(){
    var form = Object.assign({},this.state.form);
    var bool  = true;

    if(form["password"].value === "" || form["password"].value !== form["password-2"].value){
      bool = false;
    }



    if(!bool){
      console.log("wrong password");
    }else{
      console.log("new password");
      this.props.resetPassword(form["password"].value,this.state.token)
    }


  }

  render(){

    return (
      <div className="reset">
        <div className="col-2">
          <h1>{this.props.translate("reset-password.title")}</h1>
          <p>
          {this.props.translate("reset-password.ResetInformation.title")}
          </p>
          <div className="form-container">
            <form className="form-auth">
              <div><span className="icon"><i className="fas fa-key"></i></span>
              <InputPassword
                onChange={this.handleInputChange.bind(this)}
                value={this.state.form.password.value}
                name={'password'}
                isRequired={false}
                placeholder={this.props.translate("reset-password.Mot de passe.title")} 
                label={{title : this.props.translate("reset-password.Mot de passe.title")}}
              />
              </div>
              <div><span className="icon"><i className="fas fa-key"></i></span>
              <InputPassword
                onChange={this.handleInputChange.bind(this)}
                value={this.state.form["password-2"].value}
                name={'password-2'}
                isRequired={false}
                placeholder={this.props.translate("reset-password.Mot de passe 2.title")} 
                label={{title : this.props.translate("reset-password.Mot de passe 2.title")}}
              />
              </div>
            </form>
            {this.props.message !== '' ?
              <>
                {this.props.message === 'time out'  ?
                  <p>{this.props.translate("reset-password.Time-out.title")}</p> 
                  : <p>{this.props.translate("reset-password.Success.title")}</p>
                }
              </>
              : <>{this.props.message}</>
            }
          </div>
          <button className="primary-btn" onClick={this.validateNewPassword.bind(this)}>
            {this.props.translate("reset-password.Confirm.title")} 
          </button>
        </div>
        <div className="col-2 flex">
                <SvgLogin />
                {this.domainName === "aegiscertogether.com" ?
                    <img
                        className="aegis-logo-big animated"
                        alt="Aegis Logo"
                        src="https://aegiscertification.com/wp-content/uploads/2023/03/cropped-ACE-Logo-1-1.png"
                    /> :
                    <img
                        className="ikos-logo-big animated"
                        alt="IKOS Logo"
                        src="https://www.nuclearvalley.com/media/cache/resolve/medium/entreprises/logos/16636_47cab734d6e161e0d9cdfc7cf6a89830.png"
                    />
                }
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  authenticated : state.auth.authenticated,
  message : state.auth.message,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  logoutUser,
  resetPassword,
  resetMessage
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withLocalize(ResetPassword)));
